import { render, staticRenderFns } from "./FiltersPanel.vue?vue&type=template&id=8020f5e8"
import script from "./FiltersPanel.vue?vue&type=script&lang=js"
export * from "./FiltersPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports